import React from "react";
import Switch from "material-ui/Switch";
import { FormControlLabel, FormGroup } from "material-ui/Form";
import { withStyles } from "material-ui/styles";

const styles = theme => ({
  root: {
    float: "right"
  }
});

const UIFocusSwitch = props => {
  const { classes, focused, onChange } = props;
  return (
    <div className={`UIFocusSwitch ${classes.root}`}>
      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              checked={focused}
              onChange={() => {
                onChange(!focused);
              }}
            />
          }
          label={`${focused ? "Dis" : "En"}able Monitoring Mode`}
        />
      </FormGroup>
    </div>
  );
};
export default withStyles(styles)(UIFocusSwitch);



// WEBPACK FOOTER //
// ./src/UIFocusSwitch.js